import BankAccountVerification from "./images/bank-account-verification.svg";
import Loan from "./images/loan.svg";
import UploadDocuments from "./images/upload-documents.svg";
import SchedulePickup from "./images/schedule-pickup.svg";
import { addBankClicked, uploadDocumentClicked } from "./tracking";
import { PICKUP_STATUS } from "../../../constants/seller-diy-constants";

export const STEP_NAMES = {
    BANK: "BANK",
    DOCS: "DOCUMENTS",
    PICKUP: "PICKUP",
    LOAN: "LOAN"
};

export const LOAN_STEP = {
    name: STEP_NAMES.LOAN,
    icon: Loan,
    title: "Give Loan Details",
    subTitle: "Share your car loan information"
};

export const STEPS = [
    {
        name: STEP_NAMES.BANK,
        icon: BankAccountVerification,
        title: "Add Bank Account ",
        subTitle: "Share details for your car payment"
    },
    {
        name: STEP_NAMES.DOCS,
        icon: UploadDocuments,
        title: "Upload Documents",
        subTitle: "Share required car documents"
    },
    {
        name: STEP_NAMES.PICKUP,
        icon: SchedulePickup,
        title: "Schedule Pickup",
        subTitle: "Pick a date & time for car handover"
    }
];

export const TAB_STATUS = {
    VERIFIED: "VERIFIED",
    FAILED: "VERIFICATION FAILED",
    UNDER_VERIFICATION: "UNDER VERIFICATION",
    PENDING: "PENDING",
    PICKUP_SCHEDULED: "SCHEDULED",
    PICKUP_CANCELLED: "CANCELLED",
    SLOT_UNAVAILABLE: "SLOT UNAVAILABLE",
    SLOT_EXPIRED: "SLOT EXPIRED",
    ACTION_REQUIRED: "ACTION REQUIRED"
};

export const GA_STEPS = {
    [STEP_NAMES.BANK]: addBankClicked,
    [STEP_NAMES.DOCS]: uploadDocumentClicked
};
export const POPUP_TYPES = {
    BANK_ACCOUNT: "BANK_ACCOUNT",
    DOCUMENTS: "DOCUMENTS",
    SLOT_UNAVAILABLE: "SLOT_UNAVAILABLE",
    POST_SCHEDULE: "POST_SCHEDULE",
    PICKUP_CANCELLED: "PICKUP_CANCELLED"
};

export const PICKUP_NOT_ACTIVE = [
    PICKUP_STATUS.PICKUP_CANCELLED,
    PICKUP_STATUS.PICKUP_NOT_SCHEDULED
];

export const BANNER_CHOICES = [
    "500+ dealers across India",
    "Deal only in premium cars",
    "Authorised by CARS24"
];
